/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_UnavailableInputs */

const en_error_assistant_unavailable = /** @type {(inputs: Error_Assistant_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant did not answer. Ask again in a moment.`)
};

/**
* | output |
* | --- |
* | "The assistant did not answer. Ask again in a moment." |
*
* @param {Error_Assistant_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_unavailable = /** @type {((inputs?: Error_Assistant_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_unavailable(inputs)
});